import { z } from 'zod';
import { pageOf } from '#src/common/pagination.contract.js';
export const ROLE_CODE_MAX_LENGTH = 50;
export const ROLE_NAME_MAX_LENGTH = 100;
export const ROLE_DESCRIPTION_MAX_LENGTH = 500;
/** Código de perfil (`admin`, `operador-fiscal`). */
export const roleCodeSchema = z
    .string()
    .trim()
    .min(1)
    .max(ROLE_CODE_MAX_LENGTH);
/** Um perfil citado em outro lugar: o código e o nome atual. */
export const roleRefSchema = z.strictObject({
    code: z.string(),
    name: z.string(),
});
/** Quem fez uma mudança; nulo quando foi pelo CLI ou pelo próprio app. */
export const actorRefSchema = z
    .strictObject({ id: z.uuid(), name: z.string() })
    .nullable();
/**
 * Perfil e o que ele permite. O `admin` e os padrões da aplicação nascem com
 * o app; os outros, quem gere acessos cria pela tela. Nenhum é apagado: é
 * desativado. As chaves de `permissions` são validadas pelo catálogo.
 */
export const roleSchema = z.strictObject({
    code: z.string(),
    name: z.string(),
    description: z.string().nullable(),
    active: z.boolean(),
    permissions: z.array(z.string()),
    /** Pessoas ativas com o perfil: quem uma mudança alcança. */
    members: z.int().nonnegative(),
    createdAt: z.iso.datetime({ offset: true }),
});
export const rolePageSchema = pageOf(roleSchema);
export const roleEventActionSchema = z.enum([
    'created',
    'renamed',
    'described',
    'permission-added',
    'permission-removed',
    'deactivated',
    'reactivated',
]);
/**
 * Uma mudança elementar. `value` é o nome novo (`created`, `renamed`), a
 * descrição nova (`described`, nula quando foi apagada) ou a chave da
 * permissão (`permission-*`).
 */
export const roleEventSchema = z.strictObject({
    action: roleEventActionSchema,
    value: z.string().nullable(),
});
/** Mudanças feitas juntas, pela mesma pessoa. */
export const roleHistoryEntrySchema = z.strictObject({
    at: z.iso.datetime({ offset: true }),
    actor: actorRefSchema,
    events: z.array(roleEventSchema),
});
export const roleDetailSchema = z.strictObject({
    role: roleSchema,
    history: z.array(roleHistoryEntrySchema),
});
const nameSchema = z.string().trim().min(1).max(ROLE_NAME_MAX_LENGTH);
/**
 * Texto vazio vale como "sem descrição" (o serviço grava nulo). Sem
 * `transform` aqui: o schema vira JSON Schema na referência da API.
 */
const descriptionSchema = z
    .string()
    .trim()
    .max(ROLE_DESCRIPTION_MAX_LENGTH)
    .nullable();
/**
 * Cria um perfil. O código sai do nome (`Operador fiscal` vira
 * `operador-fiscal`) e não muda mais. As permissões precisam vir com as que
 * cada uma exige.
 */
export const createRoleRequestSchema = z.strictObject({
    name: nameSchema,
    description: descriptionSchema.optional(),
    permissions: z.array(z.string()),
});
/** Só os campos enviados mudam. `active: false` desativa. */
export const updateRoleRequestSchema = z
    .strictObject({
    name: nameSchema.optional(),
    description: descriptionSchema.optional(),
    permissions: z.array(z.string()).optional(),
    active: z.boolean().optional(),
})
    .refine((body) => Object.keys(body).length > 0, 'Informe ao menos um campo');
//# sourceMappingURL=roles.contract.js.map